import { difference } from 'lodash'

import { DeckLeglaity, LegalityChecker } from '../deckLegality'
import { ERRORS } from '../legality.const'

const CheckLegality: LegalityChecker = (deck: DeckLeglaity) => {
  const hasCommander = deck.checkHasCommander()

  deck.checkCanBeCommander()
  deck.checkPartners()
  deck.checkLegendaryCommander()
  deck.checkMaximumCommanders()
  deck.checkEDHBracket()

  const fullDeck = [...deck.mainboard, ...deck.commanders] // combining to check legality of all cards included in the deck
  const specificallyCommanderCategoryCards = fullDeck.filter(card => card.categories[0] === 'Commander') // Checking the name of the category here to inform users who have turned OFF the isPremier flag that their legality is wonk

  // This is _technically_ not a legality check so much as it is a user check
  // This will mark "commanders" as illegal if they're in a category called "Commander" that is not "Premier". Letting the user know of a misconfigured deck
  if (!hasCommander && specificallyCommanderCategoryCards.length) {
    for (const card of specificallyCommanderCategoryCards) {
      deck.addCardError(ERRORS.COMMANDER_CATEGORY_NOT_PREMIER, card)
    }
  }

  for (const card of fullDeck) {
    if (!hasCommander) break // Override here. We don't check color identity if there is no commander because it causes a lot of scary errors

    deck.checkCardLegality(card)
    deck.checkCardQuantity(card, 1)

    const colorDiff = difference(card.colorIdentity, deck.commandersColorIdent)

    if (colorDiff.length) deck.addCardError(ERRORS.OUTSIDE_COLOR_IDENTITY, card)
  }

  if (deck.deckSize !== 100) deck.addError(ERRORS.COMMANDER_SIZE)
}

export default CheckLegality
